import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { ArrowLeft, Wrench, Clock } from 'lucide-react';
import { useSiteSettings } from '../contexts/SiteSettingsContext';

/**
 * Branded placeholder shown when a page is Hidden / Coming Soon / Under Construction.
 * Reuses the navy TayLord Arms visual style. Prevents indexing via meta noindex.
 */
const StatusPage = ({ page, kind = 'coming_soon' }) => {
  const { business } = useSiteSettings();

  const heading = page?.coming_soon_heading
    || (kind === 'under_construction' ? 'Under Construction' : 'Coming Soon');
  const message = page?.coming_soon_message
    || (kind === 'under_construction'
      ? 'This page is being worked on. Please check back shortly.'
      : "We're finishing this up. Check back soon!");
  const Icon = kind === 'under_construction' ? Wrench : Clock;

  return (
    <>
      <meta name="robots" content="noindex,nofollow" />
      <section
        data-testid={`page-status-${kind}`}
        className="min-h-screen bg-slate-950 text-white flex items-center justify-center px-4"
      >
        <div className="max-w-lg text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-red-950/50 border border-red-900/60 mb-6">
            <Icon className="w-8 h-8 text-red-400" />
          </div>
          <h1 className="text-4xl md:text-5xl font-extrabold mb-3 tracking-tight">{heading}</h1>
          <p className="text-gray-300 mb-8 text-base leading-relaxed">{message}</p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center items-center">
            <Link to="/">
              <Button size="lg" className="bg-red-600 hover:bg-red-700 text-white" data-testid="status-back-home">
                <ArrowLeft className="w-4 h-4 mr-2" /> Back to home
              </Button>
            </Link>
            <a href={`tel:${business?.phone || ''}`} className="text-gray-400 hover:text-gray-200 text-sm">
              or call us at <span className="font-semibold text-gray-200">{business?.phone}</span>
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default StatusPage;
